var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.756 5.988h-1.372c-.228 0-.516.116-.516.572v.972s1.888 0 1.828.112l-.168 1.428-.06.916H10.7v5.996H8.3V9.988H7.1V7.644h1.2v-1.14c0-.972.456-2.572 2.568-2.572h1.888v2.056zM12.8 0H3.2A3.2 3.2 0 000 3.2v9.6A3.2 3.2 0 003.2 16h9.6a3.2 3.2 0 003.2-3.2V3.2A3.2 3.2 0 0012.8 0z","fillRule":"evenodd"}));
}

Facebook.defaultProps = {"width":"16","height":"16"};

module.exports = Facebook;

Facebook.default = Facebook;
